import React from 'react';
import { Card } from 'react-bootstrap';

const SkeletonCard = () => (
    <Card className="h-100 border-0 shadow-sm" style={{ overflow: 'hidden' }}>
        <div className="skeleton-pulse" style={{ height: '220px', background: '#e9e5dc' }} />
        <Card.Body className="p-4">
            <div className="skeleton-pulse rounded mb-3" style={{ height: '20px', width: '70%', background: '#e9e5dc' }} />
            <div className="skeleton-pulse rounded mb-2" style={{ height: '14px', width: '50%', background: '#f0ece4' }} />
            <div className="skeleton-pulse rounded mb-2" style={{ height: '14px', width: '90%', background: '#f0ece4' }} />
            <div className="skeleton-pulse rounded mb-3" style={{ height: '14px', width: '60%', background: '#f0ece4' }} />
            <div className="skeleton-pulse rounded" style={{ height: '38px', width: '100%', background: '#e9e5dc', borderRadius: '20px' }} />
        </Card.Body>
    </Card>
);

export const SkeletonGrid = ({ count = 6 }) => (
    <>
        {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="col">
                <SkeletonCard />
            </div>
        ))}
    </>
);

export const SkeletonDetail = () => (
    <div>
        <div className="skeleton-pulse mb-4" style={{ height: '400px', background: '#e9e5dc' }} />
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <div className="skeleton-pulse rounded mb-3" style={{ height: '24px', width: '60%', background: '#e9e5dc' }} />
                    <div className="skeleton-pulse rounded mb-2" style={{ height: '16px', width: '100%', background: '#f0ece4' }} />
                    <div className="skeleton-pulse rounded mb-2" style={{ height: '16px', width: '85%', background: '#f0ece4' }} />
                    <div className="skeleton-pulse rounded mb-2" style={{ height: '16px', width: '70%', background: '#f0ece4' }} />
                </div>
                <div className="col-lg-4">
                    <div className="skeleton-pulse rounded mb-3" style={{ height: '250px', background: '#e9e5dc' }} />
                    <div className="skeleton-pulse rounded mb-2" style={{ height: '16px', width: '80%', background: '#f0ece4' }} />
                </div>
            </div>
        </div>
    </div>
);

export default SkeletonCard;
